import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SearchMainEntitiesParameters, SearchMainEntitiesResultDto } from '@api-proxies';
import { EntityTypeService } from '@http/clients/entity-type.service';
import { EntityTypes } from '@models/enums/EntityTypes';
import { TabNames } from '@models/enums/TabNames';
import { CustomMenuItemComponent } from '@shared/custom-menu-item/custom-menu-item.component';
import { GenericTypeAheadDropdownComponent, IconSanitizerService } from 'ngx-lib';

interface IEntity {
    icon: SafeHtml;
    route: string;
}

@Component({
    selector: 'app-search-main-entities',
    templateUrl: './search-main-entities.component.html',
    styleUrls: ['./search-main-entities.component.scss'],
    imports: [CustomMenuItemComponent, GenericTypeAheadDropdownComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        class: 'search-main-entities'
    }
})
export class SearchMainEntitiesComponent {
    private readonly entityTypeService = inject(EntityTypeService);
    private readonly iconSanitizer = inject(IconSanitizerService);
    private readonly router = inject(Router);

    selectedEntity?: SearchMainEntitiesResultDto;

    searchResult?: SearchMainEntitiesResultDto[];

    searchText = '';

    entities: Record<number, IEntity> = {
        [EntityTypes.Company]: {
            icon: this.iconSanitizer.getIcon('companies'),
            route: '/companies-single'
        },
        [EntityTypes.Contact]: {
            icon: this.iconSanitizer.getIcon('contacts'),
            route: '/contacts-single'
        },
        [EntityTypes.Building]: {
            icon: this.iconSanitizer.getIcon('buildings'),
            route: '/buildings-single'
        },
        [EntityTypes.Opportunity]: {
            icon: this.iconSanitizer.getIcon('opportunities'),
            route: '/opportunities-single'
        },
        [EntityTypes.Account]: {
            icon: this.iconSanitizer.getIcon('accounts'),
            route: '/accounts-single'
        }
    };

    async onEntityTextChanged(): Promise<void> {
        if (!this.searchText) {
            this.searchResult = undefined;
        }
        this.searchResult = await this.entityTypeService.searchMainEntities({
            filterText: this.searchText
        } as SearchMainEntitiesParameters);
    }

    onSelectedEntity(entity: SearchMainEntitiesResultDto): void {
        this.selectedEntity = entity;
        const route = this.entities[entity.entityTypeId]?.route;
        this.router.navigate([route, entity.entityId, TabNames[TabNames.Overview]], { skipLocationChange: false });
    }
}
